import { isSenderApp } from '@/lib/app-mode';
import { isSenderTabsHidden } from '@/lib/sender-navigation';
import SenderGate from '@/pages/sender/sender-gate';
import SenderTabBar from '@/pages/sender/sender-tab-bar';
import { Outlet, useLocation } from 'react-router';

/** Session gate. Sender-app tabs live in the column shell; the panel uses a top strip. */
export default function SenderEvaShell() {
	const location = useLocation();
	const hideTabs = isSenderTabsHidden(location.pathname);

	return (
		<SenderGate>
			<div className='flex h-full min-h-0 flex-col'>
				{!isSenderApp && !hideTabs ? <SenderTabBar variant='top' /> : null}
				<div className='min-h-0 flex-1'>
					<Outlet />
				</div>
			</div>
		</SenderGate>
	);
}
